/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import moment from 'moment'
import { IconButton, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  DivFormTitle,
  ExpandPainelItemContainer,
  ExpandPainelItemLabel,
} from "./styles";
import JSONPretty from 'react-json-pretty';
import JSONPrettyMon from 'react-json-pretty/dist/adventure_time';

const EmailLogDetails = (props) => {
  const emailLog = useSelector((state) => state.emailLogs.emailLog);
  const loading = useSelector((state) => state.emailLogs.loadingEmailLog);

  return (
    <div style={styles.container}>
      {loading &&
        <div style={styles.spinner}>
          <CircularProgress />
        </div>
      }
      {(!loading && !isEmpty(emailLog)) &&
        <>
          <DivFormTitle style={styles.headerContainer}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "1.25rem",
              }}
            >
              DETALHES DO EMAIL
            </div>
            <IconButton onClick={props.closeModal} color="inherit" size="large">
              <CloseIcon />
            </IconButton>
          </DivFormTitle>
          <div style={styles.bodyContainer}>
            <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Tipo do e-mail:</ExpandPainelItemLabel>
              {emailLog.emailType}
            </ExpandPainelItemContainer>
            <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Tenant:</ExpandPainelItemLabel>
              {emailLog?.tenant?.name ? emailLog.tenant.name : '...'}
            </ExpandPainelItemContainer>
            <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Contéudo</ExpandPainelItemLabel>
              <JSONPretty id="json-pretty" data={JSON.parse(emailLog.emailContent)} theme={JSONPrettyMon}></JSONPretty>
              {/* {emailLog.emailContent} */}
            </ExpandPainelItemContainer>
            <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Data do envio:</ExpandPainelItemLabel>
              {moment(emailLog.date).format('DD/MM/YYYY')}
            </ExpandPainelItemContainer>
          </div>
        </>
      }
    </div>
  );
};

const styles = {
  container: {
    width: "50rem",
    height: "100%",
  },
  headerContainer: {
    height: "5rem",
    padding: "0 1rem 0 2rem",
    backgroundColor: "#008100",
    color: "#fff",
  },
  bodyContainer: {
    height: "calc(100% - 10rem)",
    padding: "1rem 2rem",
    overflowY: "auto",
    borderTop: "1px solid #ccc",
    borderBottom: "1px solid #ccc",
  },
  spinner: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    top: "-5px",
    opacity: "1",
    zIndex: 2,
  },
};

export default EmailLogDetails;
